export default {
  computed: {
    fulfillSitePermission() {
      return this.$store.state.users.currentUser.extra_info?.fulfill_site_permission || '';
    },

    allowAllCrud() {
      return this.fulfillSitePermission === '' || this.fulfillSitePermission.toLowerCase() === 'crud';
    },

    allowCreate() {
      return this.fulfillSitePermission === '' || this.fulfillSitePermission.toLowerCase().includes('c');
    },

    allowUpdate() {
      return this.fulfillSitePermission === '' || this.fulfillSitePermission.toLowerCase().includes('u');
    }
  },
};
